import type { ArtworkStatus } from '@artosera/ui';
import type { StatutOeuvre } from '@artosera/shared';

/**
 * `@artosera/ui` ne connaît que cinq teintes de pastille (`ArtworkStatus`),
 * l'API les statuts du cœur (D13, `docs/dev/api.md` § 13). Le libellé exact vient
 * toujours de `oeuvres:statuts.<code>` (espace de noms partagé) ; cette table
 * ne choisit que la COULEUR de la pastille — « en dépôt » et « prêtée »
 * partagent la teinte neutre, « retirée » et « archivée » aussi, comme le dit
 * déjà le libellé français de `StatusDot` (« En dépôt / prêtée »).
 */
const COULEUR_PAR_STATUT: Record<StatutOeuvre, ArtworkStatus> = {
  disponible: 'available',
  reservee: 'reserved',
  vendue: 'sold',
  en_depot: 'deposit',
  pretee: 'deposit',
  louee: 'deposit',
  retiree: 'withdrawn',
  archivee: 'withdrawn',
};

export function couleurDuStatut(statut: StatutOeuvre): ArtworkStatus {
  return COULEUR_PAR_STATUT[statut];
}

/** Statuts dans l'ordre du cartel de tri (utilisé par les filtres). */
export const STATUTS_TRIES: readonly StatutOeuvre[] = [
  'disponible',
  'reservee',
  'vendue',
  'en_depot',
  'pretee',
  'louee',
  'retiree',
  'archivee',
];
